import React, { useEffect } from 'react';
import './PrivacyPage.scss';

const PrivacyPage = () => {
    useEffect(() => {
        const previousTitle = document.title;
        document.title = 'Moral Dimension Simulation — Privacy Policy';
        document.body.classList.add('privacy-page-active');

        return () => {
            document.title = previousTitle;
            document.body.classList.remove('privacy-page-active');
        };
    }, []);

    return (
        <main className="privacy-page">
        <h1>Privacy Policy</h1>
        <p className="privacy-page__updated">Moral Dimension Simulation — last updated 2026-09-04</p>

        <p>Moral Dimension LLC ("we," "us") publishes the Moral Dimension Simulation (the "Software"). This policy explains what the Software does, and does not, do with your data.</p>

        <h2>We do not collect any data</h2>
        <p>The Software does not collect, transmit, sell, or share any personal information, usage data, analytics, or telemetry of any kind. It does not connect to the internet, contact any server, or communicate with us or any third party while running.</p>

        <h2>What the Software stores locally</h2>
        <p>The only files the Software writes to your device are ones you explicitly choose to save through its File menu:</p>
        <ul>
            <li>Simulation parameter files and simulation results you choose to save</li>
        </ul>
        <p>None of this data ever leaves your device. We have no access to it.</p>

        <h2>No accounts, no ads, no third parties</h2>
        <p>The Software does not require or support user accounts, does not display advertising, and does not integrate any third-party analytics, advertising, or tracking service.</p>

        <h2>Children's privacy</h2>
        <p>Because the Software collects no data from anyone, this includes children under 13. Nothing in the Software's operation requires or requests information about the age or identity of any user.</p>

        <h2>Changes to this policy</h2>
        <p>If this policy ever changes — for example, if a future version of the Software adds functionality that involves data collection — this page will be updated and the "last updated" date above will change accordingly.</p>

        <h2>Contact</h2>
        <p>Questions about this policy can be sent to <a href="mailto:sldcatchall@moraldimension.com">sldcatchall@moraldimension.com</a>.</p>
        </main>
    );
};

export default PrivacyPage;
